import * as React from 'react'
import Market from './Market'
import Field from './Field'
import Quiz from './Quiz'

export const SCREEN = {
	FIELD: 'FIELD',
	MARKET: 'MARKET',
	QUIZ: 'QUIZ',
	INTRO: 'INTRO'
}

export default class Srnka extends React.PureComponent {
	state = {
		screen: window.firstSignIn ? SCREEN.INTRO : SCREEN.FIELD
	}

	changeScreen = screen => {
		this.setState({ screen })
	}

	render() {
		return (
			<div className="App-screen">
				<div className="Stats">
					<div className="Stats-item">
						<i className="fa fa-usd" aria-hidden="true" />
						{this.props.data.money}
					</div>
					<div className="Stats-item">
						<i className="fa fa-cutlery" aria-hidden="true" />
						{this.props.data.food}
					</div>
					{this.props.data.happiness && (
						<div className="Stats-item">
							<i className="fa fa-smile-o" aria-hidden="true" />
							{this.props.data.happiness}
						</div>
					)}
				</div>
				{this.state.screen === SCREEN.INTRO && (
					<div className="Intro">
						<h2>Starej se o svou srnku.</h2>
						<p>
							Srnka žere jednou za hodinu. Pokaždé ti sežere
							jedno&nbsp;
							<i className="fa fa-cutlery" aria-hidden="true" />
						</p>
						<p>
							Můžeš jí kupovat mašle a další věci, které budou
							postupně přibývat.
						</p>
						<p>
							<i className="fa fa-usd" aria-hidden="true" /> můžeš
							získávat odpovídáním na různé&nbsp;
							<i className="fa fa-question" aria-hidden="true" />
						</p>
						<button
							onClick={() => this.changeScreen(SCREEN.FIELD)}
							className="Intro_button"
						>
							Pojďme na to!
						</button>
					</div>
				)}
				{this.state.screen === SCREEN.FIELD && (
					<Field {...this.props} changeScreen={this.changeScreen} />
				)}
				{this.state.screen === SCREEN.MARKET && (
					<Market {...this.props} changeScreen={this.changeScreen} />
				)}
				{this.state.screen === SCREEN.QUIZ && (
					<Quiz {...this.props} changeScreen={this.changeScreen} />
				)}
			</div>
		)
	}
}

// <FirestoreCollection
// 	path={`srnky/${this.props.srnka.id}/owns`}
// 	render={({ isLoading, data }) =>
// 		isLoading ? null : (
// 			<ul>
// 				{data.map(item => (
// 					<li key={item.id}>
// 						<PromiseRenderer
// 							promise={item.thing.get()}
// 						>
// 							{snap => (window.snap = snap) && snap.data() && snap.data().title}
// 						</PromiseRenderer>
// 						{/* <FirestoreDocument ref={item.thing}>
// 							{({ isLoading, data }) =>
// 								isLoading
// 									? null
// 									: JSON.stringify(data)
// 							}
// 						</FirestoreDocument> */}
// 						{/* {item.thing} */}
// 					</li>
// 				))}
// 			</ul>
// 		)
// 	}
// />



// WEBPACK FOOTER //
// ./src/Srnka.js